/* eslint-disable new-cap -- Genesys preset naming */
import { useCallback, useEffect, useMemo, useState } from 'react';

export const useButton = () => {
  const [isChatOpened, setIsChatOpened] = useState(false);
  const onChatClosed = useCallback(() => setIsChatOpened(false), []);
  const onChatOpened = useCallback(() => setIsChatOpened(true), []);
  const onClick = useCallback(() => {
    window.Genesys?.('command', isChatOpened ? 'Messenger.close' : 'Messenger.open');
  }, [isChatOpened]);
  useEffect(() => {
    window.Genesys?.('subscribe', 'Messenger.opened', onChatOpened);
    window.Genesys?.('subscribe', 'Messenger.closed', onChatClosed);
  }, [onChatClosed, onChatOpened]);

  return useMemo(
    () => ({
      isChatOpened,
      onClick,
    }),
    [isChatOpened, onClick],
  );
};
